import "moment/locale/id";
import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyOrder = Loadable({
    loader: () => import("pages/Order/index"),
    loading: () => <PageLoader />,
});

const LazyOrderDetail = Loadable({
    loader: () => import("pages/OrderDetail/index"),
    loading: () => <PageLoader />,
});

const LazyOrderQueue = Loadable({
    loader: () => import("pages/OrderQueue/index"),
    loading: () => <PageLoader />,
});

const LazyOrderPacking = Loadable({
    loader: () => import("pages/Packing/index"),
    loading: () => <PageLoader />,
});

const LazyOrderPackingVerification = Loadable({
    loader: () => import("pages/PackingVerification/index"),
    loading: () => <PageLoader />,
});

const LazyCourierDelivery = Loadable({
    loader: () => import("../pages/CourierDelivery"),
    loading: () => <PageLoader />,
});


function OrderRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyOrder />} />
            <Route path="/detail/:order_id" element={<LazyOrderDetail />} />
            <Route path="/queue" element={<LazyOrderQueue />} />
            <Route path="/packing" element={<LazyOrderPacking />} />
            <Route path="/packing/:order_id" element={<LazyOrderPackingVerification />} />
            <Route path="/courier" element={<LazyCourierDelivery />} />
        </Routes>
    );
}

export default OrderRoute;
